module.exports = __webpack_public_path__ + "images/play@1x.png?7551d5dc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play@1x.png
// module id = 675
// module chunks = 7